import { Box } from '@rsos/base-components';

// NOTE: currently design chooses to keep it just empty, but for modularization
// keeing it as a separate file
const NoResultsState = () => <Box />;

export default NoResultsState;
